import { render, staticRenderFns } from "./quotationGenerator.vue?vue&type=template&id=4d82256c&scoped=true&"
import script from "./quotationGenerator.vue?vue&type=script&lang=js&"
export * from "./quotationGenerator.vue?vue&type=script&lang=js&"
import style0 from "./quotationGenerator.vue?vue&type=style&index=0&id=4d82256c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82256c",
  null
  
)

export default component.exports